import React, { useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

function FaceCropOrMatch({ handleResponse, name }: any) {
  const serviceName = name.replaceAll(" ", "").toLowerCase();
  const errorObject = {
    cardError: false,
    userImageError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedCard, setUploadedCard] = useState<any>("");
  const [uploadedUserImage, setUploadedUserImage] = useState<any>("");
  const [cardPreview, setCardPreview] = useState<string>("");
  const [userImagePreview, setUserImagePreview] = useState<string>("");

  const handleFileUpload = async (
    card: any,
    userImage: any,
    consent: string
  ) => {
    const cardEncoded: any = await toBase64(card);
    const finalCardImage = cardEncoded.replace(
      /^data:image\/[a-zA-Z0-9.+-]+;base64,/i,
      ""
    );
    setLoading(true);
    if (serviceName === "facecrop") {
      return handleResponse({ finalCardImage, consent }, setLoading);
    }

    const userImageEncoded: any = await toBase64(userImage);
    const finalUserImage = userImageEncoded.replace(
      /^data:image\/[a-zA-Z0-9.+-]+;base64,/i,
      ""
    );
    handleResponse({ finalCardImage, finalUserImage, consent }, setLoading);
  };

  function toBase64(image: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }

  function handleCheck() {
    if (!uploadedCard) {
      setError(() => ({
        ...error,
        cardError: true,
      }));
      return false;
    } else if (serviceName === "facematch" && !uploadedUserImage) {
      setError(() => ({
        ...error,
        userImageError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    const consent = isChecked === true ? "Y" : "N";

    handleFileUpload(uploadedCard, uploadedUserImage, consent);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>Card Image</label>
            <input
              type="file"
              id="id-input-face-crop" data-testid="id-input-face-crop"
              onChange={(e: any) => {
                const file = e.target.files[0];
                setUploadedCard(file);
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () =>
                    setCardPreview(
                      (reader.result as string).replace(
                        /^data:image\/\w+;base64,/,
                        ""
                      )
                    );
                  reader.readAsDataURL(file);
                } else {
                  setCardPreview("");
                }
              }}
              className={Styles.fileUpload}
            />
            {cardPreview && (
              <img
                src={`data:image/jpeg;base64,${cardPreview}`}
                alt="Card Preview"
                style={{
                  width: "220px",
                  height: "220px",
                  objectFit: "cover",
                  borderRadius: 8,
                  marginBottom: 8,
                  border: "1px solid #e8e8e8",
                  marginTop: "8px",
                }}
              />
            )}
            {error.cardError && (
              <ErrorMessage>Please upload a file</ErrorMessage>
            )}
          </div>
          {serviceName === "facematch" && (
            <div className="d-flex flex-column mb-4 ">
              <label className={`${Styles.label} flex-grow-1`}>
                User Image
              </label>
              {userImagePreview && (
                <img
                  src={`data:image/jpeg;base64,${userImagePreview}`}
                  alt="User Preview"
                  style={{
                    width: "220px",
                    height: "220px",
                    objectFit: "cover",
                    borderRadius: 8,
                    marginBottom: 8,
                    border: "1px solid #e8e8e8",
                    marginTop: "8px",
                  }}
                />
              )}
              <input
                type="file"
                id="id-input-face-crop-back" data-testid="id-input-face-crop-back"
                onChange={(e: any) => {
                  const file = e.target.files[0];
                  setUploadedUserImage(file);
                  if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () =>
                      setUserImagePreview(
                        (reader.result as string).replace(
                          /^data:image\/\w+;base64,/,
                          ""
                        )
                      );
                    reader.readAsDataURL(file);
                  } else {
                    setUserImagePreview("");
                  }
                }}
                className={Styles.fileUpload}
              />
              {error.userImageError && (
                <ErrorMessage>Please upload a file</ErrorMessage>
              )}
            </div>
          )}
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input {...testIdProps("consent-checkbox-face-crop-or-match")}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-face-crop"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaceCropOrMatch;
